/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-underscore-dangle */

import { Cancel } from 'axios'

export const isCancel = (value: any | Cancel) => {
  return !!(value && value.__CANCEL__)
}

export default isCancel
